module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex h-screen"
  }, [(_vm.getProfile.role !== 'admin') ? _c('div', {
    staticClass: "bg-primary-light fixed z-20",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('Sidebar', {
    staticClass: "h-full overflow-hidden",
    on: {
      "showSideMenu": _vm.showSideMenu
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-full overflow-x-hidden",
    attrs: {
      "id": "mainContainer"
    }
  }, [_c('Header', {
    attrs: {
      "changeHeader": _vm.changeHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-height overflow-y-auto",
    attrs: {
      "id": "container-body"
    },
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll.apply(null, arguments)
      }
    }
  }, [_vm._t("default")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1ee52cbe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/default/default.vue
// module id = 923
// module chunks = 61